<template>
  <section class="roboverse-third-section">
    <div
      class="headline"
      data-aos="fade-right"
      data-aos-easing="ease-out-cubic"
      data-aos-offset="0"
      data-aos-delay="100"
      data-aos-duration="1000"
      data-aos-once="true"
    >
      <div class="title-line1">
        <span>RELEASE</span>
        <div class="circle"></div>
      </div>
    </div>
    <div :class="'plan-img ' + locale"></div>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "RoboverseThirdMobileSection",
  computed: {
    ...mapState("app", {
      locale: (state) => state.locale,
    }),
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/font.css";
@import "~@/assets/css/image.less";
.roboverse-third-section {
  position: relative;
  // height: calc(100vw / 1280 * 720);
  height: 5.74rem;
  background-color: #000;
  padding-top: 0.6rem;
  box-sizing: border-box;

  .headline {
    margin-left: 0.95rem;

    .title-line1 {
      position: relative;
      font-family: "HarmonyOS Sans SC Bold";
      font-style: normal;
      font-weight: 900;
      font-size: 0.59rem;
      line-height: 0.53rem;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      background: linear-gradient(269.44deg, #00ff00 -4%, #00ffc2 102.4%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;

      .circle {
        position: absolute;
        left: -0.5rem;
        top: -0.3rem;
        width: 0.89rem;
        height: 0.89rem;
        background: rgba(255, 255, 255, 0.16);
        backdrop-filter: blur(5px);
        /* Note: backdrop-filter has minimal browser support */
        border-radius: 50%;
        animation: blur-anim 2.5s ease-in-out 500ms infinite alternate;
      }
    }
  }
  .plan-img {
    width: 6.23rem;
    height: 2.3rem;
    margin: 0.57rem 0 0 0.87rem;
    background-image: url("@{thirdPlanImg}");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    &.en {
      background-image: url("@{thirdPlanEnImg}");
    }
  }

  @keyframes blur-anim {
    from {
      left: -0.5rem;
    }

    to {
      left: 2.5rem;
    }
  }
}
</style>
